import React from 'react';
import ChartErrorBoundary from '../common/ChartErrorBoundary';
import TopInfluencersTable, { type TopInfluencer } from './TopInfluencersTable';
import TopPostsTable from './TopPostsTable';
import type { TopPost } from '@/hooks/useTopPerformingPosts';

export interface TopPerformersSectionProps {
  topInfluencers: TopInfluencer[];
  aggregatesLoading: boolean;
  onToggleShowAllInfluencers: () => void;
  topPosts: TopPost[];
  postsLoading: boolean;
  onToggleShowAllPosts: () => void;
}

export const TopPerformersSection: React.FC<TopPerformersSectionProps> = ({
  topInfluencers,
  aggregatesLoading,
  onToggleShowAllInfluencers,
  topPosts,
  postsLoading,
  onToggleShowAllPosts,
}) => {
  return (
    <>
      {/* Top Performers */}
      <ChartErrorBoundary title="Top Performing Influencers">
        <TopInfluencersTable
          data={topInfluencers}
          info="Ranks creators by CPE — who drove the most engagement per rupee spent."
          isLoading={aggregatesLoading}
          showViewAll={true}
          onViewAll={onToggleShowAllInfluencers}
        />
      </ChartErrorBoundary>

      {/* Top Performing Posts */}
      <ChartErrorBoundary title="Top Performing Posts">
        <TopPostsTable
          data={topPosts}
          info="Discover the content that's driving the best results across your campaign."
          isLoading={postsLoading}
          showViewAll={true}
          onViewAll={onToggleShowAllPosts}
        />
      </ChartErrorBoundary>
    </>
  );
};

export default TopPerformersSection;
